import { Button, Text } from "@aidron/aidron-ds";
import { CustomHeading } from "../../StyledComponents/styleComponents.index";

export const CancelModalButton = ({
  isPurchaseHistoryPage = false,
  t,
  onClose,
  patchOrders,
  setShowInputs,
  setInputs,
  setShowCancelModal,
  selectedOrderId,
  setShowCancelModalOrderRollback,
}) => {
  const overlayStyle = {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(2px)",
  };

  if (isPurchaseHistoryPage) {
    const modalStyle = {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "24px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
      maxWidth: "480px",
      textAlign: "center",
    };

    return (
      <div style={overlayStyle} onClick={onClose}>
        <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <p style={{ color: "red", marginBottom: "20px", fontWeight: "500" }}>
            {t("cancelOrderReturnToEdit")}
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
            <Button
              onClick={() => setShowCancelModalOrderRollback(false)}
              label="Voltar"
              icon="layout"
              type="filled"
              size="sm"
            />
            <Button
              onClick={() => patchOrders()}
              label="Confirmar"
              icon="layout"
              type="filled"
              disabled={!selectedOrderId}
              size="sm"
            />
          </div>
        </div>
      </div>
    );
  }

  const modalStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  };

  const handleClose = () => {
    setShowInputs && setShowInputs(false);
    setInputs && setInputs({});
    setShowCancelModal && setShowCancelModal(false);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <CustomHeading size="sm" margin="0 0 16px">
          {t("attention")}
        </CustomHeading>

        <Text label={t("editWarning")} />

        <div style={{ display: "flex", justifyContent: "space-around", gap: "1rem" }}>
          <Button label={t("save")} type="filled" onClick={handleClose} />
          <Button label={t("dontSave")} type="outlined" onClick={handleClose} />
        </div>
      </div>
    </div>
  );
};